export const BUILD_TIME_DARK_MODE_ENABLED = false;

export const isDarkModeEnabled = (debugPanelDarkMode: boolean): boolean => BUILD_TIME_DARK_MODE_ENABLED || debugPanelDarkMode;
